module.exports = __webpack_public_path__ + "static/media/8_manual.76272bc9.png";